// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1__kD","cls2":"ProfilePdfPackCard-cls2_nko ProfilePdfPackCard-cls1__kD"};